import {Outlet, useParams} from "react-router-dom";
import {useEffect} from "react";
import {DeskHub} from "_services/ws/desk-hub";
import {open} from "_pages/client/desk/components/RequestIdentification";
import { useAttendanceNoSuspense } from "_api/hooks/Client/attendances";

export const RoomHub = () => {
    const {deskId} = useParams();
    const {attendanceId} = useParams();
    const {attendance} = useAttendanceNoSuspense(attendanceId);

    useEffect(() => {
        if (!deskId)  {
            return;
        }

        if (!DeskHub.loadGeneratedToken(deskId)) {
            open();
        }
    }, [deskId]);

    useEffect(() => {
        (async () => {
            if((attendance && !attendance.finishedAt) || !attendanceId) {
                await DeskHub.connect();
            }
        })();
    }, [attendance]);

    return (
        <Outlet/>
    );
}
